import React from "react";
import { Col, Row } from "react-bootstrap";
import { isRgbColorEnabled, getScaleColors } from "../../../../../../Helpers/RgbColorHelper";

export default function Detail_CircleBar({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);

  // Check if RGB color is enabled using helper
  const rgbEnabled = isRgbColorEnabled(item.scale);

  // Get color variations using helper
  const colors = getScaleColors(item.scale);

  const hitRange = item.scale.ranges.find((scale) => scale.isHit);

  // Yuvarlak progress bar için SVG
  const CircularProgressBar = ({ score, variant }) => {
    const radius = 50;
    const strokeWidth = 8;
    const normalizedRadius = radius - strokeWidth * 2;
    const circumference = normalizedRadius * 2 * Math.PI;
    const strokeDasharray = `${circumference} ${circumference}`;
    const strokeDashoffset = circumference - (score / 100) * circumference;

    return (
      <div className="d-flex flex-column align-items-center">
        <div className="position-relative">
          <svg height={radius * 2} width={radius * 2} className="transform-rotate-minus-90">
            {/* Background circle */}
            <circle
              stroke="#e6e6e6"
              fill="transparent"
              strokeWidth={strokeWidth}
              r={normalizedRadius}
              cx={radius}
              cy={radius}
            />
            {/* Progress circle */}
            <circle
              stroke={colors.primary}
              fill="transparent"
              strokeWidth={strokeWidth}
              strokeDasharray={strokeDasharray}
              style={{ strokeDashoffset }}
              strokeLinecap="round"
              r={normalizedRadius}
              cx={radius}
              cy={radius}
            />
          </svg>
          {/* Score text in center */}
          <div
            className="position-absolute top-50 start-50 translate-middle text-center"
            style={{ fontSize: "18px", fontWeight: "bold", color: colors.dark }}
          >
            {elementScore}%
          </div>
        </div>
        {/* Hit range text below circle */}
        <div className=" text-center" style={{ fontSize: "12px", color: colors.dark }}>
          {hitRange.text}
        </div>
      </div>
    );
  };

  return (
    <Row className="justify-content-center mx-0 mb-2">
      <Row>
        <Col xs="2" className="d-flex justify-content-center align-items-center">
          <CircularProgressBar score={elementScore} variant={isSub ? "sub-scope" : "main-scope"} />
        </Col>
        <Col>
          {/* Sub-scope name (when isSub is true) */}
          <Row className={"justify-content-center "}>
            <Col xs={"auto"} className="_detail-section-sub-scope-name-header-pdf align-content-center">
              {isSub && (
                <span
                  style={{
                    color: rgbEnabled ? colors.primary : undefined,
                    fontWeight: rgbEnabled ? "bold" : undefined,
                    fontSize: "16px",
                  }}
                  className={!rgbEnabled ? "sub-scope-name-color-wrap-up" : ""}
                >
                  {item.scopeName}
                </span>
              )}
            </Col>
          </Row>

          {/* Component title */}
          <Row className={"justify-content-center mb-1"}>
            <Col xs={"auto"} className="detail-section-scope-name-header-wrap-up-old align-content-center">
              <span
                style={{
                  color: rgbEnabled ? colors.dark : undefined,
                  fontWeight: rgbEnabled ? "bold" : undefined,
                  fontSize: "18px",
                }}
                className={
                  !rgbEnabled ? (!isSub ? "main-scope-name-color-wrap-up" : "sub-scope-name-color-wrap-up") : ""
                }
              >
                {isSub ? item.name : item.scopeName}
              </span>
            </Col>
          </Row>

          <Row>
            <Col>
              {item.generalInformationText?.length > 2 && (
                <div
                  className="detail-scale-general-info-text-wrap-up"
                  dangerouslySetInnerHTML={{ __html: item.generalInformationText }}
                />
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </Row>
  );
}
